import React from 'react';
import Language from '../language/language';
import { withRouter } from 'react-router-dom';
import Modal from '../modal/modal'
import classnames from 'classnames'
import { inject, observer } from 'mobx-react';
import moment from 'moment'
import { Select } from 'antd';
import './stylesheets/gameMeetingForm.scss'

const Option = Select.Option;

@inject('personGameStore', 'languageStore')
@withRouter
@observer
export default class GameTimeReservation extends React.Component {

  constructor(props) {
    super(props)
    this.filterMeetings = this.filterMeetings.bind(this)
  }
  state = {
    registrationId: undefined,
    selectedDate: '',
    meetingOptions: [],
    selectedMeetingId: undefined,
    gameMeetingModal: false,
    messages: {
      dateError: '',
      timeError: ''
    },
    selectDirectionMeetings: [],
    //最终的面试数据:
    meetingsWithDateFiltered: [],
    meetingsObj: [],
    meetingsArr: [],
    meetingsObjFull: [],
    selectDateOptions: null,
    isFull: false
  }

  componentDidMount () {

    let registrationId = undefined
    const { gameData } = this.props
    if (gameData && gameData.id) registrationId = gameData.id

    this.setState({
      registrationId
    })
    this.props.onClick(this);
    
    this.filterMeetings();
    
  }

  handleDateChange = (optionStr) => {
    this.setState({
      selectedDate: this.state.meetingsObj[optionStr],
      meetingOptions: this.state.meetingsObj[optionStr],
      selectedMeetingId: undefined,
    })
  }

  handleMeetingChange = (meetingId) => {
    if (meetingId) {
      this.setState({
        selectedMeetingId: meetingId
      })
    }
  }

  formatMeeting (option) {
    if(moment(option.beginAt).format('YYYY-MM-DD') !== moment(option.endAt).format('YYYY-MM-DD')) {
      return `${moment(option.beginAt).format('YYYY.MM.DD HH:mm')} ~ ${moment(option.endAt).format('YYYY.MM.DD HH:mm')}`
    }
    if (!option || !option.beginAt || !option.endAt) return '数据异常'
    return `${moment(option.beginAt).format('HH:mm')} ~ ${moment(option.endAt).format('HH:mm')}`
  }
  
  checkValues = () => {
    if(this.props.required){
      let dateError = ''
      let timeError = ''
      if (!this.state.selectedDate) {
        dateError = <Language resource="INTERVIEW_DATE_REQUIRE" />
      }
      if (!this.state.selectedMeetingId) {
        timeError = <Language resource="INTERVIEW_TIME_REQUIRE" />
      }
      this.setState({
        messages: {
          dateError,
          timeError
        }
      })
      if (!dateError && !timeError) {
        return true
      }
      else {
        return false
      }
    } else {
      return true
    }
  }

  showConfirmSubmit = () => {
    if (this.checkValues()) {
      this.setState({
        gameMeetingModal: true
      })
    }
  }

  closeConfirmSubmit = () => {
    this.setState({
      gameMeetingModal: false
    })
  }

  submitForm = () => {
    const form = {
      variables: {
        input: {
          attributes: {
            meetingId: this.state.selectedMeetingId,
            registrationId: this.state.registrationId
          }
        }
      }
    }
    this.props.personGameStore.setMeetingForm(form)
    this.props.personGameStore.submitMeetingForm().then(() => {
      this.setState({
        gameMeetingModal: false
      })
      this.props.personGameStore.getGameInfo(this.props.match.params.id)
    })
  }

  filterMeetings () {
    const meetingsObj = {};
    const meetingsArr = [];
    const meetingsObjFull = {};

    let meetingsWithDirection = [];
    let meetingsWithDateFiltered = [];
    if(this.props.personGameStore.selectDirectionId){
      //有技术方向的面试数据
      meetingsWithDirection = this.props.meeting.meetings.filter(meeting => {
        if(meeting.goptionId === this.props.personGameStore.selectDirectionId) {
          return true
        }
        if(!meeting.hasGoption) {
          return true
        }
        return false
      })
    } else {
      //没有选技术方向，将有绑定技术方向的数据过滤
      meetingsWithDirection = this.props.meeting.meetings.filter(meeting => !meeting.hasGoption)
    }
    // 2. 确认面试数据是否跨天
    meetingsWithDateFiltered = meetingsWithDirection.map((meeting) => {
      const { beginAt, endAt } = meeting;
      const beginAtDate = new Date(beginAt);
      const endAtDate = new Date(endAt);
      let acrossDate = true;
      if(beginAtDate.getYear() === endAtDate.getYear() && beginAtDate.getMonth() === endAtDate.getMonth() && beginAtDate.getDay() === endAtDate.getDay()) {
        acrossDate = false;
      }
      return {
        ...meeting,
        acrossDate
      }
    });

    meetingsWithDateFiltered.forEach((meeting) => {
      const { acrossDate, date, beginAt} = meeting;
      // 不跨天
      if(!acrossDate) {
        if(!Array.isArray(meetingsObj[date])) {
          meetingsObj[date] = [];
        }
        meetingsObj[date].push(meeting);
        if(!meetingsArr.includes(date)) {
          meetingsArr.push(date);
        } 
      } else {
        // 跨天
        if(!Array.isArray(meetingsObj[beginAt])) {
          meetingsObj[beginAt] = [];
        }
        meetingsObj[beginAt].push(meeting);
        if(!meetingsArr.includes(beginAt)) {
          meetingsArr.push(beginAt);
        } 
      }
    });
    meetingsArr.forEach((meetingStr) => {
      let isAllFull = false;
      // 如果全部都为full，那么这个时段就没法预约了
      const hasSeatMeetings = meetingsObj[meetingStr].filter((meeting) => {
        if(meeting.full) {
          return false;
        }
        return true;
      });
      if(hasSeatMeetings.length === 0) {
        isAllFull = true;
      }
      meetingsObjFull[meetingStr] = isAllFull;
      
    });

    this.setState({
      meetingsWithDateFiltered,
      meetingsObj,
      meetingsArr,
      meetingsObjFull
    })
  }

  renderForm () {
    return (
      <div className="form-content time-form-content">
        <div className="form-input">
          <div className="select">
            <div className={classnames({
            "normal-label": true,
            "isRequired": this.props.required,
            })} style={{width:'113px'}}>
              <label><Language resource="CHOOSE_DATE" /></label>
            </div>
            <div className="normal-wrapper time-normal-wrapper">
              <Select onChange={this.handleDateChange}>
                {this.state.meetingsArr.map((optionStr) => {
                  let option = this.state.meetingsObj[optionStr][0];
                  let isAllFull = this.state.meetingsObjFull[optionStr]
                  let weekDay = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];  
                  // 获取当前日期
                  let date = new Date();
                  // 获取当前月份
                  let nowMonth = date.getMonth() + 1;
                  // 获取当前是几号
                  let strDate = date.getDate();
                  // 添加分隔符“-”
                  let seperator = "-";
                  // 对月份进行处理，1-9月在前面添加一个“0”
                  if (nowMonth >= 1 && nowMonth <= 9) {
                    nowMonth = "0" + nowMonth;
                  }
                  // 对月份进行处理，1-9号在前面添加一个“0”
                  if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                  }
                  // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
                  let nowDate = date.getFullYear() + seperator + nowMonth + seperator + strDate;
                  let showDate = option.batchDate ? option.batchDate : option.aloneDate
                  //时间预约数据
                  let meetingWeek = option.aloneDate && weekDay[new Date(option.aloneDate).getDay()];
                  return  <Option key={option.id} value={optionStr} disabled={ isAllFull }>{showDate}<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>{showDate === nowDate ? "(" + (isAllFull ? '已约满' : '可预约') + ')' : '('+(meetingWeek ? meetingWeek + ',': '')+(isAllFull ? '已约满' : '可预约') + ')'}</Option> 
                })}
              </Select>
            </div>
          </div>
          {this.state.messages.dateError
            ? 
              <div className="error">
                {this.state.messages.dateError}
              </div>
            : null
          }
        </div>
        <div className="form-input">
          <div className="select">
            <div className={classnames({
              "normal-label": true,
              "isRequired": this.props.required,
            })} style={{width:'113px'}}>
            <label><Language resource="CHOOSE_TIME" /></label>
            </div>
            <div className="normal-wrapper time-normal-wrapper">
              <Select value={this.state.selectedMeetingId} onChange={this.handleMeetingChange}>
                {this.state.meetingOptions.map((option) => {
                  return <Option disabled={option.full} key={option.id} value={option.id}>{this.formatMeeting(option)} { moment(option.beginAt).format('YYYY-MM-DD') !== moment(option.endAt).format('YYYY-MM-DD') ? <br/> : null }{option.full ? <Language resource="MEETING_IS_FULL" /> : null}</Option>
                })}
              </Select>
            </div>
          </div>
          {this.state.messages.timeError
            ? 
              <div className="error">
                {this.state.messages.timeError}
              </div>
            : null
          }
        </div>
      </div>
    )
  }

  render () {
    
    return (
      <div className="game-form-meeting game-form-time-meeting">
        { this.renderForm()
        }
        <Modal className="model-confirm-tip"  title={<Language resource="CONFIRM_SUBMIT_FORM" />}  state={this.state.gameMeetingModal}  close={this.closeConfirmSubmit} >
          <div className="confirm-tip">
            <Language resource="CONFIRM_SUBMIT_MEETING" />
          </div>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/formList/gameTimeReservationForm.js